


















import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import { YorN } from 'ncp-api-supporter';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import ToolTip from '@/pro/components/common/tooltip/ToolTip.vue';
import { InputNumber } from '@/pro/types';
import { RadioBoxGroupOption } from '@/pro/helpers/type';
@Component({
  components: { RadioGroup, ToolTip },
})
export default class MinorPurchase extends Vue {
  @PropSync('minorPurchaseYn', { required: true })
  private minorPurchaseYnSync: YorN;
  @Prop({ required: true })
  private readonly mallNo: InputNumber;
  // @Prop({ required: true })
  // private readonly gradeType: AllNoneAny;
  @Prop({ required: true })
  private readonly productNo: number;

  @Prop({ required: true })
  private readonly disabled: boolean;

  private radioOption: RadioBoxGroupOption<YorN> = {
    name: 'minorPurchaseYn',
    data: [
      {
        id: 'minorPurchaseN',
        name: 'minorPurchaseYn',
        value: 'Y',
        display: 'PRO_PRODUCT_COMMON_NOT_USE',
      },
      {
        id: 'minorPurchaseY',
        name: 'minorPurchaseYn',
        value: 'N',
        display: 'PRO_PRODUCT_COMMON_USE',
      },
    ],
  };

  public resetMinorPurchase() {
    this.minorPurchaseYnSync = 'Y';
  }

  private goToAdultCertification() {
    if (this.mallNo) {
      window.open(`${this.$router.resolve({ name: 'MallCreate' }).href}/${this.mallNo}`, 'edit_mall');
      return;
    }
    this.$router.push({ name: 'MallList' });
  }
}
